import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"
import fevicon_icon from "../../assets/images/favicon.png"

const SEO = ({
  title,
  description,
  canonical,
  image,
  noindex = false,
  isServicePage = false,
  serviceName,
  serviceType,
  structuredData = null,
  faqData = null,
}) => {
  const { pathname } = useLocation()
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  )

  const siteUrl = site.siteMetadata.siteUrl
  const seoCanonical = canonical || `${siteUrl}${pathname}`

  const siteTitle =
    title || "SrashtaSoft | Flutter & Mobile App Development Company, Ahmedabad"
  const siteDescription =
    description ||
    "SrashtaSoft is a software development company delivering web, mobile, and AI solutions."
  // const robots = noindex ? "noindex, nofollow" : "index, follow"
  const serviceSchema =
    isServicePage && seoCanonical
      ? {
          "@context": "https://schema.org",
          "@type": "Service",
          name: serviceName || title || siteTitle,
          serviceType: serviceType || serviceName || title || siteTitle,
          description: siteDescription,
          url: seoCanonical,
          provider: {
            "@type": "Organization",
            name: "SrashtaSoft",
            url: "https://srashtasoft.com/",
          },
          areaServed: {
            "@type": "Place",
            name: "Worldwide",
          },
          ...(image ? { image } : {}),
        }
      : null

  const faqSchema =
    faqData && faqData.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqData.map(item => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.answer,
            },
          })),
        }
      : null

  const schemaNodes = [serviceSchema, faqSchema, structuredData].filter(Boolean)

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <link rel="icon" href={fevicon_icon} />
      <meta name="description" content={siteDescription} />
      <meta property="og:site_name" content="SrashtaSoft" />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      {image ? (
        <meta property="og:image" content={image} />
      ) : (
        <meta
          property="og:image"
          content="static/favicon.ico"
        />
      )}
      <meta name="twitter:card" content="summary_large_image" />
      {/* <meta name="robots" content={robots} /> */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap"
        rel="stylesheet"
      />
      <link rel="canonical" href={seoCanonical} />
      <meta name="google-site-verification" content="CODE" />
      {schemaNodes.length
        ? schemaNodes.map((schemaNode, index) => (
            <script
              key={index}
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaNode) }}
            />
          ))
        : null}
    </Helmet>
  )
}

export default SEO
